(function () {
    "use strict";

    class securityCheckResult {
        constructor(resultCode, label) {
            this.resultCode = resultCode;
            this.label = label;
            this.style = this.resultCode === 12 ? "bg-success" : "bg-danger";
        }
    }

    angular.module("app").controller("PersonCheckDialogController", PersonCheckDialogController);

    PersonCheckDialogController.$inject = ["PersonCheckDialogContext","assistanceInService",];
    function PersonCheckDialogController(PersonCheckDialogContext, assistanceInService) {

        const vm = this;

        vm.possibleResults = getPossibleResults();
        
        vm.Person = PersonCheckDialogContext.getPerson();
        vm.discard = PersonCheckDialogContext.discard;
        vm.submit = PersonCheckDialogContext.submit;

        vm.canEnterResult = vm.Person.SecurityCheckResult === 0;
        // Clear the "Initial" result to enable the angular validation
        if (vm.canEnterResult)
            vm.Person.SecurityCheckResult = null;

        function getPossibleResults() {
            return assistanceInService.assistanceInResultCodes.map(c => new securityCheckResult(c.Key, c.Value));
        }
    }
})();
